import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';


@Component({
    selector: 'app-submission-success',
    templateUrl: './submission-success.component.html',
    styleUrls: ['./submission-success.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SubmissionSuccessComponent {
  config: any; // TODO We need to remove this any datatype

  constructor(private mdr: MatDialogRef<SubmissionSuccessComponent>, @Inject(MAT_DIALOG_DATA) data: MatDialog, private router: Router ) {
    this.config = data;
  }

  closeDialog(): void {
    this.mdr?.close(false);
    this.router.navigate(['/customer-submission/dashboard']);
  }
}
